import { render } from "./ModalProductBatchForm.vue?vue&type=template&id=152ff14c"
import script from "./ModalProductBatchForm.vue?vue&type=script&lang=js"
export * from "./ModalProductBatchForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__